import bp from 'shared/constants/breakpoints'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  position: fixed;
  right: 1em;
  top: calc(60px + 1em);
  display: grid;
  grid-row-gap: 0.5em;
  z-index: 9999;

  & > div {
    width: 300px;

    @media screen and (max-width: ${bp.small}) {
      width: 300px;
    }
  }
`

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5em;
`
